import { render, staticRenderFns } from "./DutiesOfConsumer.vue?vue&type=template&id=14c49664&scoped=true&"
import script from "./DutiesOfConsumer.vue?vue&type=script&lang=js&"
export * from "./DutiesOfConsumer.vue?vue&type=script&lang=js&"
import style0 from "./DutiesOfConsumer.vue?vue&type=style&index=0&id=14c49664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c49664",
  null
  
)

export default component.exports